export default __webpack_public_path__ + "static/media/s_twitter_d.44ddec1b.svg";